import type { ComponentOverride } from '../types';

export const MuiInputAdornment: ComponentOverride<'MuiInputAdornment'> = {
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        '& > .MuiIconButton-root': {
          '&:focus': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
  },
};
